import React from 'react'
import classnames from '../../../utils/classnames'
import Spinner from 'components/common/Spinner';

const Input = ({ className, loading, ...rest }) => {
    const classNames = classnames('border border-black p-2', className, { 'cursor-not-allowed': loading });

    return (
        <div className="relative w-fit">
            <input className={classNames} {...rest} />
            {
                loading && (
                    <Spinner className="absolute right-3 top-1/2 w-auto h-3/4 -translate-y-1/2" />
                )
            }
        </div>
    )
}

export default Input